import Store from "../configureStore";
import { PROJECT_USER_ID } from "../constants/storageKeys";
import {
  CUSTODIAN_PROJECT_USER_ID,
  PROJECT_USER_ID as FILTER_PROJECT_USER_ID
} from "../constants/filters";

export default projectUserObject => {
  let teams;
  if (projectUserObject.length > 0) {
    teams = projectUserObject[0].project_user_teams;
    if (teams.length > 0) {
      return teams.map(team => team.team_id);
    }
  }
};

export const getTeamIdForGivenProjectUser = useLoginUser => {
  const project = Store.getState().Init.data.project;
  let projectUserId;
  if (useLoginUser) {
    projectUserId = parseInt(localStorage.getItem(PROJECT_USER_ID));
  } else {
    const searchParam = new URLSearchParams(window.location.search);
    projectUserId = parseInt(
      searchParam.get(CUSTODIAN_PROJECT_USER_ID) ||
        searchParam.get(FILTER_PROJECT_USER_ID)
    );
  }
  const custodianProjectUser = project.project_users.filter(
    projectUser => projectUser.id === projectUserId
  );

  if (custodianProjectUser.length === 1) {
    const cpuo = custodianProjectUser[0];
    if (cpuo.project_user_teams.length === 1) {
      const cpuot = cpuo.project_user_teams[0];
      return cpuot.team_id;
    }
  }
};
